import { Col } from "reactstrap";
import { H6, LI } from "../../../../AbstractElements";
import { OrderList } from "../../../../Constant";

const OrderListCol = () => {
    let datas =[1,2,3,4,5]
  return (
    <Col sm="12" xl="4">
      <H6 className="sub-title">{OrderList}</H6>
      <ol>
        <LI>Lorem ipsum dolor sit amet</LI>
        <LI>Lorem ipsum dolor sit amet</LI>
        <LI>Lorem ipsum dolor sit amet</LI>
        <LI>
          <ol>
            {datas.map((data)=>(<LI key={data}>Lorem ipsum dolor sit amet</LI>))}
          </ol>
        </LI>
        <LI>Lorem ipsum dolor sit amet</LI>
        <LI>Lorem ipsum dolor sit amet</LI>
      </ol>
    </Col>
  );
};

export default OrderListCol;
